<template>
    <span v-if="item" >
        <div v-if="configHtml" :title="configTitle" v-html="configHtml"></div>
        <span v-if="!item.isActive" class="badge badge-danger">Disabled</span>
        <span v-if="!item.isPaid" class="badge badge-danger">UnPaid</span>
        <span v-if="!item.isPremium" class="badge badge-danger">UnPremium</span>
        &nbsp;
        
        <a href="javascript:void(0);" class="text-primary" title="Toggle Config" @click="showAllConfig">
            <i class="fa fa-refresh"></i>
        </a>
        <a href="javascript:void(0);" class="text-warning" title="Edit Customer" @click="editCustomizeFn">
            <i class="fa fa-edit"></i>
        </a>
    </span>
</template>
<style scoped>
 
</style>
<script>
import Vue from "vue";
export default Vue.extend({
    data() {
        return {
            edited:false,
            type:'',
            val:null,
            item:null,
            configTitle:null,
            configHtml:null,
            showAll:false,
            options:[
                {name:'Paid Plan',value:"isPaid"},{name:'Bypass Rules',value:"bypassRules"},
                {name:'Sync All Status',value:"devSyncAllSts"},{name:'Map Author',value:"hdAuthorId"},{name:'Sync Attachments',value:"syncAttachments"},
                {name:'Search Tab',value:"allowSearch"},{name:'Config Option',value:"allowConfigOpt"},{name:'Auto Create ADO',value:"autoCreateADO"},{name:'Auto Create HD',value:"autoCreateHD"},
                //{name:'Auto Syncing Reverse',value:"autoSyncing"},{name:'Auto Syncing Forward',value:"autoSyncingFwd"},
                {name:'Premium Plan',value:"isPremium"},{name:'Users API Access',value:"isUsersAccess"},{name:'Custom Fields',value:"allowFields"},
                {name:'Nodes/Iterations',value:"allowNodes"},{name:'Tags Access',value:"allowTags"},{name:'Custom Workitem Types',value:"allowCTypes"},
                {name:'Active',value:"isActive"},{name:'Deleted',value:"isDeleted"},{name:'Files Upload',value:"uploadFiles"}
            ],
            selectedOptions:[]
        }
    },
    created(){
        const _self=this;
        _self.val=_self.params.value;
        _self.item=_self.params.data;
        _self.showAll=localStorage['showAllConfig']=='True'?true:false;
        _self.buildConfigHtml();
    },
    methods:{
        showAllConfig(){
            const _self=this;
            _self.showAll=!_self.showAll;
            _self.buildConfigHtml();
        },
        buildConfigHtml(){
            const _self=this;
            let configTitle='';
            let configHtml='<div>';
            let fields=_self.options.map(d=>d.value);
            let count=0;
            _self.selectedOptions=[];
            for(var i=0;i<fields.length;i++){
                
                if(_self.item[fields[i]]!=0 && _self.item[fields[i]]!=null){
                    let fieldName=_self.options.find(d=>d.value==fields[i]).name;
                    _self.selectedOptions.push(_self.options.find(d=>d.value==fields[i]))
                    configTitle+=`${fieldName}, `

                    if(count%2==0 && (count<=2 || _self.showAll)){
                        configHtml+=`</div><div>`
                    }
                    count+=1;
                    if(count<=2 || _self.showAll){
                        configHtml+=`<span class="badge badge-primary">${fieldName}</span>`
                    }
                    
                }
                
            }
             
            _self.configTitle=configTitle?configTitle.substr(0,configTitle.length-2):configTitle;
            _self.configHtml=configHtml;
        },
        editCustomizeFn(){
            const _self=this;
            let data=_self.params.data;
            data.type=_self.type;
            data.selectedOptions=_self.selectedOptions;
            _self.params.context.componentParent.editCustomerConfig(data);
        },
    },
    components:{}
});
</script>
